import { examBase } from "../../../types";
import './index.scss';
import { useNavigate } from "react-router-dom";
import { Box, Stack, useMediaQuery } from "@mui/material";



const ExamInfoTile = ({
    examBase
}:{
    examBase: examBase
}) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:950px)");

    const handleClick = () => {
        navigate(`/exam-component-catalog/${examBase.id}`)
    };

    return (
        <Stack direction='row' sx={{ width:'100%', mb:2, justifyContent:'center' }}>
            {!isMobile && (
                <Box
                    component="img"
                    src={examBase.image ? `/images/${examBase.image}` : '/images/CVESD_logo.png'}
                    sx={{ width: 100, height: "auto", maxWidth: "100%", bgcolor:'#8babf1', borderTopLeftRadius:20, borderBottomLeftRadius:20, p:2 }}
                />
            )}
            <div className="outer-shell">
                <div className="display-row">

                    <h4 onClick={handleClick}>{examBase.exam_title}</h4>
                </div>
                <p>{examBase.description}</p>
            </div>
        </Stack>
    )
};

export default ExamInfoTile;